import styled from "styled-components";

export const Footer = styled.div`
  background-color: var(--orange);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 167px;

  #father-div {
    max-width: 1300px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    padding: 20px;

    p,
    div > svg,
    button {
      color: var(--white);
    }

    div {
      display: flex;
      gap: 10px;

      a {
        color: white;

        :visited {
          color: white;
        }

        svg {
          cursor: pointer;
        }
      }
    }

    button {
      background-color: transparent;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      
      a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        color: white;

        :visited {
          color: white;
        }

        svg {
          font-size: 20px;
        }
      }
    }
  }

  @media (min-width: 601px) {
    #father-div {
      flex-direction: row;

      p {
        font-weight: 500;
        font-size: 18px;
        line-height: 130%;
      }

      div a svg {
        font-size: 20px;
      }

      button {
        font-weight: 600;
        font-size: 18px;
        line-height: 130%;

        svg {
          font-size: 25px;
        }
      }
    }
  }
`;
